export default "__VITE_ASSET__BMrv9KJY__"